import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import React from 'react'
import loginBg from '../assets/images/login-bg.jpg'

const PublicLayout = ({ children, urlParams }) => {
  return (
    <Box
      h="100vh"
      backgroundRepeat="no-repeat"
      backgroundPosition="center"
      backgroundSize="cover"
      position="relative"
      color="white"
      backgroundImage={`url(${loginBg})`}
    >
      <Flex justifyContent="space-evenly" h="100%">
        <Flex alignItems="center" flexDirection="column" flexGrow="1">
          {!!urlParams ? null : (
            <Flex
              h="100%"
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Box minW="250px" p={6}>
                <Heading
                  as="h1"
                  fontWeight="800"
                  size="3xl"
                  color="white"
                  textShadow="0px 2px 2px rgba(0, 0, 0, 0.25)"
                >
                  Welcome to GRID
                </Heading>
                <Text color="white" fontSize="3xl">
                  Login to access your app
                </Text>
              </Box>
            </Flex>
          )}
          <Text
            fontWeight="800"
            fontSize="md"
            color="white"
            alignSelf="flex-end"
            flexBasis="5%"
          >
            GRID
          </Text>
        </Flex>
        <Flex justifyContent="center" flexGrow="1">
          <Flex
            flex={1}
            h="full"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
          >
            {children}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default PublicLayout
